interface ILocalitySchema {
  cityName?: string;
  stateName?: string;
  regionCode?: string;
  rvParkDestination?: string;
  hikingTrails?: string[];
}

export const localitySchema = ({
  cityName,
  stateName,
  regionCode,
  rvParkDestination,
  hikingTrails,
}: ILocalitySchema) => {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Place',
    name: stateName ? `${cityName}, ${stateName}` : cityName,
    address: {
      '@type': 'PostalAddress',
      addressLocality: cityName,
      addressRegion: regionCode,
    },
    description: rvParkDestination,
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'State',
        value: regionCode,
      },
      ...(hikingTrails
        ? [
            {
              '@type': 'PropertyValue',
              name: 'HikingTrails',
              value: hikingTrails.slice(0, 5), // Array of trail names (top 5 hiking)
            },
          ]
        : []),
    ],
  };
  return schemaData;
};
